<template>
  <Select v-model="data" class="select-tree" ref="select" :disabled="disabled" clearable :transfer="transfer"
    @on-clear="clear" @on-open-change="openChange" transfer-class-name="select-tree">
    <Option disabled :value="data||''" :label="data||''">
      <organizeTree :params='params' @selectNode="selectNode" :type="type=='child'?'selectChild':'select'" ref="tree" :typeTree="typeTree" :isAll="isAll"></organizeTree>
    </Option>
  </Select>
</template>
<script>
import organizeTree from "@/components/system/organizeTree";
export default {
  components:{organizeTree},
  props: {
    value: null,
    name: null,
    type: null,
    isAll:false,
    disabled:false,
    typeTree: null,
    transfer: {
      default:true,
    },
	params:{}
  },
  data() {
    return {
      data:"",
    };
  },
  watch: {
    name(){
      this.data = this.name;
    },
    value(val){
      if(!val){
        this.data = '';
      }else {
      }
    }
  },
  methods: {
    openChange(){
      this.$refs.tree.init();
    },
    clear(){
      console.log("clear");
      this.data = "";
      this.$emit("input",'');
      this.$emit("change",{});
    },
    selectNode(nodeArr, cur){
      this.data = cur.name;
      this.$refs.select.hideMenu();
      this.$emit("input",cur.id);
      this.$emit("change",cur);
    },
  },

};
</script>

<style lang="scss" scoped>
.ivu-transfer {
  text-align: center;
  /deep/ .ivu-transfer-list {
    text-align: left;
  }
}
.powerModal {
  /deep/ .ivu-modal-body {
    height: 500px;
    overflow-y: auto;
  }
}
</style>
